<div class="container_title">
    <div class="title_box">
        <div class="lender_title">{{lenderName}}</div>
        <div>{{sellerServicerNumber}}</div>
    </div>

    <div class="title_box_rate">
        <div class="rate_box border_right">
            <div>ACQUISITIONS</div>
            <div *ngIf="isNotNumberAcquisitions == false">{{noAcquisitions | number}}</div>
            <div *ngIf="isNotNumberAcquisitions == true">{{noAcquisitions}}</div>
        </div>
        <div class="rate_box border_right">
            <div>COMPLIANCE RATE</div>
            <div *ngIf="isNotNumber == false">{{rateCompliance | percent}}</div>
            <div *ngIf="isNotNumber == true">{{rateCompliance}}</div>
        </div>
        <div class="rate_box">
            <div>SUBMISSION RATE</div>
            <div *ngIf="isNotNumber == false">{{rateSubmission | percent}}</div>
            <div *ngIf="isNotNumber == true">{{rateSubmission}}</div>
        </div>        
    </div>
</div>
